enum ClientInfoLinkType {
  BALANCE = 'BALANCE',
  COMMUNICATION = 'COMMUNICATION',
  MEMBERSHIP = 'MEMBERSHIP',
}

export default ClientInfoLinkType
